/* eslint-disable react/no-string-refs */
import React from 'react';
import filterOptionValues from '../../../../constants/filterOptionValues';
import i18n from "i18next";

class RequestStatusSelector extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const isManager = this.props.filterOptionValue === 'admin';

    return (
      <div className="form-group" style={{ marginBottom: 0 }}>
        {this.props.title ? (
          <label>
            {this.props.title}
          </label>
        ) : null}
        {
              this.props.isReport || isManager
                ? (
                  <select
                    ref="select"
                    className="form-control input-sm border-input select-input"
                    value={this.props.value || 0}
                    onChange={this.onChange}
                    id="statusManager"
                  >
                    {
                          filterOptionValues[this.props.filterOptionValue].requestStats.map((r, i) => (
                            <option key={i} value={r.value}>
                              {i18n.t(r.text)}
                            </option>
                          ))
                      }
                  </select>
                )
                : (
                  <select
                    ref="select"
                    className="form-control input-sm border-input select-input"
                    value={this.props.value || 0}
                    onChange={this.onChange}
                    id="status"
                  >
                    <option value="all">
                      {i18n.t("All")}
                    </option>
                    <option value="pending">
                      {i18n.t("aWaitingApproval")}
                    </option>
                    <option value="waiting_for_cancelled">
                      {i18n.t("waitingForCancelConfirmation")}
                    </option>
                    <option value="cancelled">
                      {i18n.t("cancellations")}
                    </option>
                    <option value="completed">
                      {i18n.t("approvals")}
                    </option>
                    <option value="rejected">
                      {i18n.t("rejects")}
                    </option>
                  </select>
                )
          }
      </div>
    );
  }
}

RequestStatusSelector.defaultProps = {
  isReport: false
};

export default RequestStatusSelector;



// WEBPACK FOOTER //
// ./src/components/common/selector/status/index.js